import axios from "axios"
import { baseUrl } from "../assets/Animations"
const myToken = localStorage.getItem('token')
const myHeader = {
    headers: { Authorization: `Bearer ${myToken}` }
}

export const freshTask = () => ({
    todoId: Math.random().toString(16).slice(2),
    todoName: "New Task...",
    todoDescription: "Notes...",
    todoDueDate: new Date(),
    todoAlarm: false,
    todoOwner: '',
    whichList: 'todos',
    whichSchool: 'all',
    todoSubtasks: []
})

export const freshSubtask = () => ({
    subtaskId: Math.random().toString(16).slice(2), 
    subtaskName: 'New Subtask', 
    subtaskDueDate: new Date(), 
    subtaskAlarm: false, 
    subtaskCompleted: false, 
    subtaskSubtasks: []
})

export const freshSubSubtask = () => ({
    subtask2xId: Math.random().toString(16).slice(2),
    subtask2xName: 'New mini todo...',
    subtask2xCompleted: false
})

export const taskCardAnimateIn = (wrapperId, cardId) => {
    document.getElementById(wrapperId).style.opacity = 1
    document.getElementById(cardId).style.right = '400px'
}

export const taskCardAnimateOut = (wrapperId, cardId) => {
    document.getElementById(wrapperId).style.opacity = 0
    document.getElementById(cardId).style.right = '-400px'
}

export const taskChipCheckOffAnimation = (id) => {
    document.getElementById(id).style.transform = 'scale(2)'
    document.getElementById(id).style.opacity = 0
}

export const calculateTasksDueToday = (todos, workflows, setNumberBriDueToday, setNumberCourtneyDueToday) => {
    let briCounter = 0
    let courtneyCounter = 0
    for(let i = 0; i < todos.length; i++) {
        let todo = todos[i]
        if (new Date(todo.todoDueDate) < new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && new Date(todo.todoDueDate) > new Date().setHours(1,0,0,0) && todo.todoOwner === 'Bri') {
            briCounter = briCounter + 1
        }
    }
    for(let i = 0; i < workflows.length; i++) {
        let todo = workflows[i]
        if (new Date(todo.todoDueDate) < new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && new Date(todo.todoDueDate) > new Date().setHours(1,0,0,0) && todo.todoOwner === 'Bri') {
            briCounter = briCounter + 1
        }
    }
    for(let i = 0; i < todos.length; i++) {
        let todo = todos[i]
        if (new Date(todo.todoDueDate) < new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && new Date(todo.todoDueDate) > new Date().setHours(1,0,0,0) && todo.todoOwner === 'Courtney') {
            courtneyCounter = courtneyCounter + 1
        }
    }
    for(let i = 0; i < workflows.length; i++) {
        let todo = workflows[i]
        if (new Date(todo.todoDueDate) < new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && new Date(todo.todoDueDate) > new Date().setHours(1,0,0,0) && todo.todoOwner === 'Courtney') {
           courtneyCounter = courtneyCounter + 1
        }
    }
    setNumberBriDueToday(briCounter)
    setNumberCourtneyDueToday(courtneyCounter)
}